var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100 destination-auto-complete"},[_c('div',{},[_c('vue-select',{staticClass:"border-0 ml-2 w-100",attrs:{"placeholder":_vm.placeholder,"disabled":_vm.inputDisabled,"options":_vm.$store.state.planner.destinations,"label":"name"},on:{"input":_vm.updateValue},scopedSlots:_vm._u([{key:"option",fn:function(ref){
var name = ref.name;
var address = ref.address;
return [_c('h4',{staticStyle:{"margin":"0"}},[_vm._v(_vm._s(name))]),_c('em',[_vm._v(_vm._s(address))])]}},{key:"no-options",fn:function(ref){
var search = ref.search;
var searching = ref.searching;
return [(searching)?[_vm._v(" No results found for "),_c('em',[_vm._v(_vm._s(search))]),_vm._v(". ")]:_vm._e()]}}])})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }